import { css } from '@emotion/react';

import { theme, typography } from '@adflow/frontend/ui-theme';

const depthColors = ['#F3F9F0', '#E1F0DA', '#D0DFC9', '#AEBEA7'];

export const outlineColor = (depth?: number) =>
	depthColors[depth ? depth - 1 : 0];
const borderWidths = (depth?: number) => ['8', '4', '2', '1'][(depth || 1) - 1];

export const sharedStyles = {
	subtitle: css(typography.subTitle, {
		marginTop: '1.5rem',
		marginBottom: '1rem',
	}),
	container: (depth?: number) =>
		css({
			marginLeft: '0.75rem',
			borderLeft: `${borderWidths(depth)}px solid ${outlineColor(depth)}`,
			borderBottom: `${borderWidths(depth)}px solid ${outlineColor(depth)}`,
			borderBottomLeftRadius: '10px',
			width: '100%',
		}),
	grid: css(
		{
			display: 'grid',
			gridTemplateColumns: 'repeat(8, minmax(4rem, 1fr))',
			marginTop: '0.25rem',
			marginBottom: '0.25rem',
			paddingLeft: '1.5rem',
			columnGap: '1.25rem',
			rowGap: '0.25rem',
		},
		{
			[`@media (max-width: ${theme.screens.lg})`]: css({
				gridTemplateColumns: 'repeat(4, minmax(7rem, 1fr))',
			}),
		}
	),
	gridFormContainer: css({
		display: 'flex',
		flexWrap: 'wrap',

		marginTop: '0.25rem',
		marginBottom: '0.5rem',
	}),
	add: css({
		maxWidth: 'max-content',
		marginBottom: '0.5rem',
		paddingLeft: '0.75rem',
		cursor: 'pointer',
		':hover': { textDecoration: 'underline' },
		color: theme.colors.palettes.primary.main,
		'& svg': css({
			alignSelf: 'center',
			display: 'inline',
			marginLeft: '0.25rem',
		}),
	}),
};
